import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import I18n from 'I18n';
import FileExtensionFilters from '../enums/FileExtensionFilters';
import { getFileFilteringErrorMessage } from './i18n';
import { getIsFileExternal, getIsFilePrivate } from 'FileManagerCore/utils/fileAccessibility';
import { getThumbnailTooltipI18nKey } from 'FileManagerCore/utils/thumbnailTooltip';
export const getIsFileExtensionNotSupported = (fileExtension, extensions, filterType) => {
  if (filterType === FileExtensionFilters.NONE) {
    return false;
  }
  const isFileInExtensions = extensions.has(fileExtension);
  return filterType === FileExtensionFilters.SUPPORTED ? !isFileInExtensions : isFileInExtensions;
};
const getNotSupportedReason = (extensions, reasons, fileExtension, filterType) => {
  return reasons.get(fileExtension) || getFileFilteringErrorMessage(extensions, filterType);
};
export const isInsertFileDisabled = (file, isHostAppContextPrivate) => {
  return getIsFileExternal(file) || getIsFilePrivate(file) && !isHostAppContextPrivate;
};
export const addSupportInfoToFiles = (files, filter, isHostAppContextPrivate) => {
  const extensions = filter.get('extensions');
  const reasons = filter.get('reasons');
  const filterType = filter.get('filterType');
  return files.map(file => {
    if (extensions.count() && filterType !== FileExtensionFilters.NONE) {
      const fileExtension = file.get('extension');
      const notSupported = getIsFileExtensionNotSupported(fileExtension, extensions, filterType);
      if (notSupported) {
        return file.merge({
          notSupported,
          notSupportedReason: notSupported && getNotSupportedReason(extensions, reasons, fileExtension, filterType)
        });
      }
    }
    if (isInsertFileDisabled(file, isHostAppContextPrivate)) {
      return file.merge({
        notSupported: true,
        notSupportedReason: I18n.text(getThumbnailTooltipI18nKey(file, isHostAppContextPrivate))
      });
    }
    return file;
  });
};
export const getFileExtensionFromRawFile = rawFile => rawFile.name.split('.').pop();
export const isExtensionFromRawFileSupported = (rawFile, filter) => !getIsFileExtensionNotSupported(getFileExtensionFromRawFile(rawFile), filter.get('extensions'), filter.get('filterType'));
export const buildFilterFromPOJOs = (filterType, filteredExtensions, filteredReasons) => {
  return ImmutableMap({
    extensions: ImmutableSet(filteredExtensions),
    reasons: ImmutableMap(filteredReasons),
    filterType: filterType || FileExtensionFilters.NONE
  });
};
export const getIsDrawerWithFileExtensionFilterConfigValid = (props = {}) => {
  const filteredExtensionsSet = ImmutableSet(props.filteredExtensions || []);
  if (props.filterType !== FileExtensionFilters.NONE) {
    return filteredExtensionsSet.size > 0;
  }
  return true;
};